import { ChallengeQuestionKey } from '@/application/shared/domain/ChallengeQuestion';
import { OtpChannel } from '@/shared/domain/OtpChannel';

export interface ChallengeQuestionSettings {
  otp: OtpSettings,
  questions: QuestionSettings
}

export interface OtpSettings {
  enabled: boolean;
  channels: Array<OtpChannel>;
}

export interface QuestionSettings {
  enabled: boolean;
  fields: ChallengeQuestionFields;
}

export type ChallengeQuestionFields = {
  [key in ChallengeQuestionKey]: boolean;
}

export enum ChallengeType {
  APPLICATION = 'application',
  FEEDBACK = 'feedback',
}
